import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLifebuoyIconWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_2",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .lifebuoy-icon-st0 {\n        fill: #fff;\n      }\n    " }) }), /* @__PURE__ */ _jsx("g", {
		id: "Layer_1-2",
		children: /* @__PURE__ */ _jsx("path", {
			className: "lifebuoy-icon-st0",
			d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12,12-5.4,12-12S18.6,0,12,0ZM21,16.4l-2.6-1.5c.4-.9.6-1.9.6-2.9s-.2-2-.6-2.9l2.6-1.5c.6,1.3,1,2.8,1,4.4s-.4,3.1-1,4.4h0ZM2,12c0-1.6.4-3.1,1-4.4l2.6,1.5c-.4.9-.6,1.9-.6,2.9s.2,2,.6,2.9l-2.6,1.5c-.6-1.3-1-2.8-1-4.4h0ZM7,12c0-2.8,2.2-5,5-5s5,2.2,5,5-2.2,5-5,5-5-2.2-5-5ZM16.4,3l-1.5,2.6c-.9-.4-1.9-.6-2.9-.6s-2,.2-2.9.6l-1.5-2.6c1.3-.6,2.8-1,4.4-1s3.1.4,4.4,1h0ZM7.6,21l1.5-2.6c.9.4,1.9.6,2.9.6s2-.2,2.9-.6l1.5,2.6c-1.3.6-2.8,1-4.4,1s-3.1-.4-4.4-1h0Z"
		})
	})]
});
export default SvgLifebuoyIconWhite;
